import React from 'react';
import { Card } from '@/components/ui/card';
import { Progress } from '@/components/ui/progress';
import { Badge } from '@/components/ui/badge';
import { BookOpen, CheckCircle, Lock } from 'lucide-react';

interface LearningPath {
  id: string;
  title: string;
  description: string;
  progress: number;
  modules: number;
  completedModules: number;
  isLocked: boolean;
  difficulty: 'beginner' | 'intermediate' | 'advanced';
}

export function LearningPathPanel() {
  const learningPaths: LearningPath[] = [
    {
      id: '1',
      title: 'Frontend Development Fundamentals',
      description: 'Master the basics of web development',
      progress: 60,
      modules: 5,
      completedModules: 3,
      isLocked: false,
      difficulty: 'beginner'
    },
    {
      id: '2',
      title: 'Advanced JavaScript Concepts',
      description: 'Deep dive into JavaScript programming',
      progress: 0,
      modules: 4,
      completedModules: 0,
      isLocked: true,
      difficulty: 'advanced'
    }
  ];

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Learning Paths</h2>
      <div className="space-y-6">
        {learningPaths.map((path) => (
          <div 
            key={path.id}
            className={`relative p-4 rounded-lg ${
              path.isLocked ? 'bg-slate-800/30' : 'bg-slate-800/50'
            }`}
          >
            {path.isLocked && (
              <div className="absolute right-4 top-4">
                <Lock className="w-5 h-5 text-slate-400" />
              </div>
            )}
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <h3 className="font-medium">{path.title}</h3>
                <Badge variant="outline">{path.difficulty}</Badge>
              </div>
              <p className="text-sm text-slate-400">{path.description}</p>
              <div className="flex items-center justify-between text-sm text-slate-400">
                <div className="flex items-center gap-2">
                  <BookOpen className="w-4 h-4" />
                  <span>{path.completedModules}/{path.modules} modules</span>
                </div>
                <span>{path.progress}% complete</span>
              </div>
              <Progress value={path.progress} className="h-2" />
            </div>
          </div>
        ))}
      </div>
    </Card>
  );
}